<template>
    <div :class="bgClasses" :style="style">
        <header v-if="smallLogo">
            <div class="navbar fixed-top">
                <router-link class="navbar-brand" to="/">
                    <img src="img/logo.svg" alt="" />
                </router-link>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div :class="containerClasses">
                        <div class="content min-vh-100 flex-column d-flex justify-content-between">
                            <section v-if="!smallLogo">
                                <h1 class="logo-xl mb-0">
                                    <router-link class="navbar-brand" to="/">
                                        <img src="/img/logo-xl.svg" class="img-fluid" alt="Insurance 4 Models App" />
                                    </router-link>
                                </h1>
                            </section>
                            <section>
                                <b-alert 
                                    v-model="message.show" 
                                    :variant="message.type" 
                                    :dismissible="message.dismissible" 
                                    >{{ message.text }}</b-alert>
                                <router-view 
                                    v-on:show-message="showMessage" 
                                    v-on:set-style="setStyle" 
                                    v-on:set-small-logo="setSmallLogo"
                                    v-on:set-bg-classes="setBgClasses"
                                    v-on:set-container-classes="setContainerClasses">
                                </router-view>
                            </section>
                            <section class="logos"></section>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <Footer/>
    </div>
</template>

<script>
import Footer from '../components/Footer'

export default {
    name: 'OnboardLayout',
    components: {
        'Footer': Footer,
    },
    beforeRouteLeave (to, from, next) {
        //console.log("beforeRouteLeave");
        this.message = {
                show: false,
                text: '',
                type: "info",
                dismissible: true
            };
        next();
    },
    data: function() {
        return {
            bgClasses : 'bg bg-img',
            containerClasses : 'col-12 col-md-6 col-lg-4',
            style : '', //default
            smallLogo: false,
            message: {
                show: false,
                text: '',
                type: "info",
                dismissible: true
            }
        }
    },
    methods: {
        showMessage: function(message){
            this.message = {
                ...this.message,
                ...message,
                show: true,
            }
        },
        setStyle: function(style){
            this.style = style
        },
        setBgClasses: function(classes){
            this.bgClasses = classes
        },
        setContainerClasses: function(classes){
            this.containerClasses = classes
        },
        setSmallLogo: function(){
            this.smallLogo = true
        }
    }
}
</script>